const displayProfileColor = (profile_color, type) => {
    return `profile-color ${type} ${!!profile_color ? profile_color : 'primary-coral'}`;
};
export default displayProfileColor;
